import { ERROR_CLEAR, LOADING, SUCCESS_CLEAR } from 'domain/types/base/base';
import { AppThunk } from '../../../utils/reducerUtil';

export function BaseAction(): AppThunk {
    return async dispatch => {
        dispatch({
            payload: true,
            type: LOADING
        });
    };
}

export function RemoveErrors(): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: undefined,
            type: ERROR_CLEAR
        });
    };
}

export function RemoveSuccess(): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: undefined,
            type: SUCCESS_CLEAR
        });
    };
}